const BUTTERFLY_SVG = (color) => `
<svg width="20" height="18" viewBox="0 0 24 22" fill="${color}" aria-hidden="true">
  <g class="wing wl">
    <path d="M11.2 10.5C8 3.5 2 2 1.4 6.6c-.5 4 4.6 6.2 9.8 5.6z"/>
    <path d="M11.2 11.8c-4.2.8-7.4 3.6-5.8 6.6 1.4 2.4 5.8-.4 6.4-3.4z"/>
  </g>
  <g class="wing wr">
    <path d="M12.8 10.5C16 3.5 22 2 22.6 6.6c.5 4-4.6 6.2-9.8 5.6z"/>
    <path d="M12.8 11.8c4.2.8 7.4 3.6 5.8 6.6-1.4 2.4-5.8-.4-6.4-3.4z"/>
  </g>
  <ellipse cx="12" cy="12" rx="1.1" ry="5.2" fill="#061224"/>
</svg>`;

export function spawnButterflies(x, y) {
  const layer = document.getElementById("butterfly-layer");
  if (!layer) return;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  for (let i = 0; i < 5; i++) {
    const b = document.createElement("span");
    b.className = "butterfly";
    b.style.left = `${x}px`;
    b.style.top = `${y}px`;
    b.style.setProperty("--dx", `${Math.round(Math.random() * 170 - 85)}px`);
    b.style.setProperty("--dy", `${Math.round(-(55 + Math.random() * 110))}px`);
    b.style.setProperty("--rot", `${Math.round(Math.random() * 70 - 35)}deg`);
    b.innerHTML = BUTTERFLY_SVG(i % 2 ? "#00B4D8" : "#1E3A8A");
    layer.appendChild(b);
    setTimeout(() => b.remove(), 1100);
  }
}
